import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileBase64 from 'react-file-base64';
import { resizeImage } from 'function/resizeImage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import SubCard from 'ui-component/cards/SubCard';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import {
    Alert,
    Avatar,
    Box,
    Button,
    ButtonBase,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Collapse,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputBase,
    InputLabel,
    MenuItem,
    Pagination,
    Paper,
    Select,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
    useMediaQuery
} from '@mui/material';
import axios from 'axios';
import ApiLink from 'API';
import { useTheme } from '@mui/styles';
import useScriptRef from 'hooks/useScriptRef';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { gridSpacing } from 'store/constant';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import PanoramaIcon from '@mui/icons-material/Panorama';
import NumberFormat from 'react-number-format';
import { useNavigate } from 'react-router';
import InvoicePDF from './InvoicePDF';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import InvoicePDF_Short from './InvoicePDF_Short';
import InvoiceQuotationPDF from './InvoiceQuotationPDF';
import InvoiceReceiptPDF from './InvoiceReceiptPDF';
import { PDFViewer, Font } from '@react-pdf/renderer';
import { BrowserView, MobileView } from 'react-device-detect';
import PdfPreview from 'ui-component/PdfPreview';
import phetsarath_ot from '../../assets/fonts/phetsarath_ot.ttf';

Font.register({
    family: 'Noto Sans Lao',
    src: 'https://cdn.jsdelivr.net/gh/googlefonts/noto-fonts@master/hinted/ttf/NotoSansLao/NotoSansLao-Regular.ttf'
});

const ViewInoice = ({ Open, setOpen, DataInvoice }) => {
    const handleClose = () => {
        setOpen(false);
    };
    const [dataShortArr, setdataShortArr] = useState([]);
    const descriptionElementRef = React.useRef(null);

    React.useEffect(() => {
        if (Open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }

            try {
                const dataShort = [];
                if (DataInvoice.stockController && DataInvoice.stockController.length !== 0) {
                    DataInvoice.stockController.forEach((item) => {
                        // Group by product + price + TYPE so a same-model unit of a
                        // different type (normal / display / repaired) lands on its
                        // own summary row.
                        const existing = dataShort.find(
                            (x) => x.productId === item.productId && x.price === item.salePrice && x.type === (item.type || 'normal')
                        );
                        if (existing) {
                            existing.amount += 1;
                        } else {
                            dataShort.push({
                                productId: item.productId,
                                price: item.salePrice,
                                createBy: item.createBy,
                                invoiceNumber: item.invoiceNumber,
                                saleDate: item.saleDate,
                                rateSale: item.rateSale,
                                branchCode: item.branchCode,
                                productName: item.productName,
                                model: item.model,
                                color: item.color,
                                memory: item.memory,
                                storage: item.storage,
                                type: item.type || 'normal',
                                amount: 1
                            });
                        }
                    });
                }
                setdataShortArr(dataShort);
            } catch (error) {
                console.error('Error grouping products:', error);
            }
        }
    }, [Open, DataInvoice]);

    const theme = useTheme();
    const navigate = useNavigate();
    const [AlertBox, setAlertBox] = useState({ open: false, message: '', severity: 'error' });
    const [view, setView] = React.useState('list');
    const handleChange = (event, nextView) => {
        if (nextView !== null) {
            setView(nextView);
        }
    };
    return (
        <div>
            <Dialog
                fullWidth
                maxWidth="lg"
                open={Open}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PanoramaIcon color="primary" />
                            <Typography variant="h4" component="span">
                                Invoice Preview
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <ToggleButtonGroup orientation="horizontal" value={view} exclusive onChange={handleChange} size="small">
                                <ToggleButton value="list" aria-label="list">
                                    <ViewListIcon />
                                </ToggleButton>
                                <ToggleButton value="model" aria-label="model">
                                    <ViewModuleIcon />
                                </ToggleButton>
                                <ToggleButton value="quotation" aria-label="quotation">
                                    <RequestQuoteOutlinedIcon />
                                </ToggleButton>
                                <ToggleButton value="receipt" aria-label="receipt">
                                    <ReceiptLongIcon />
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                        <IconButton onClick={handleClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers={true} sx={{ p: 0 }}>
                    <Collapse in={AlertBox.open}>
                        <Alert
                            sx={{ m: 1 }}
                            severity={AlertBox.severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertBox({ ...AlertBox, open: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {AlertBox.message}
                        </Alert>
                    </Collapse>
                    <Box sx={{ width: '100%' }}>
                        <PdfPreview
                            key={view}
                            document={
                                view === 'model' ? (
                                    <InvoicePDF_Short data={DataInvoice} dataShort={dataShortArr} isDocumentOnly={true} />
                                ) : view === 'quotation' ? (
                                    <InvoiceQuotationPDF data={DataInvoice} isDocumentOnly={true} />
                                ) : view === 'receipt' ? (
                                    <InvoiceReceiptPDF data={DataInvoice} isDocumentOnly={true} />
                                ) : (
                                    <InvoicePDF data={DataInvoice} isDocumentOnly={true} />
                                )
                            }
                            fileName={DataInvoice?.invoiceNumber || 'Invoice'}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 2 }}>
                    <Button variant="outlined" color="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ViewInoice;
